module.exports = __webpack_public_path__ + "static/img/screenshot-2.7bb6e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-2.png
// module id = 06Dc
// module chunks = 0